import * as actionTypes from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
const Url = process.env.REACT_APP_MAIN_URL;
export const AddService = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.SET_LOADING, payload: true });
  try {
    await axios.post(`${Url}appointment`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    dispatch({ type: actionTypes.ADD_SERVICE });
    toast.success("Appointment booked successfully");
  } catch (error) {
    const message =
      error?.response?.data?.status ||
      error?.message ||
      "Something went wrong. Please try again.";
    toast.error(message);
  } finally {
    dispatch({ type: actionTypes.SET_LOADING, payload: false });
  }
};
